// Helper to notify other components in the same tab 
export function notifyUserUpdated(user = null) {
  // Dispatch a CustomEvent for same-tab listeners
  try {
    const event = new CustomEvent('userUpdated', { detail: user });
    window.dispatchEvent(event);
  } catch (err) {
    // If CustomEvent isn't available for some reason, silently continue
    console.warn('userUpdated event dispatch failed', err);
  }
  // Also write to localStorage so other tabs receive the storage event
  try {
    if (user === null) {
      // write a timestamp marker
      localStorage.setItem('user_updated_at', String(Date.now()));
    } else {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('user_updated_at', String(Date.now()));
    }
  } catch (err) {
    // ignore storage errors
  }
}
export default notifyUserUpdated;